import { motion } from "framer-motion";

const BlackLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <motion.div
      className="fixed inset-0 flex flex-col items-center justify-center bg-black/25 backdrop-blur-sm z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="relative flex items-center justify-center">
        {/* Rotating Ring (Black) */}
        <motion.div
          className="w-24 h-24 border-4 border-transparent border-t-black border-b-black rounded-full"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.2, ease: "linear" }}
        />

        {/* Inner Pulsing Dot (Black) */}
        <motion.div
          className="absolute w-16 h-16 bg-black rounded-full opacity-50"
          animate={{ scale: [1, 1.3, 1], opacity: [0.4, 0.8, 0.4] }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
        />

        {/* Outer Glow Effect (Subtle Black Border) */}
        <motion.div
          className="absolute w-32 h-32 border-2 border-black rounded-full opacity-30"
          animate={{ scale: [1, 1.2, 1], opacity: [0.2, 0.6, 0.2] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        />
      </div>

      {/* Animated "Loading..." Text (Dark Gray for contrast) */}
      <motion.p
        className="mt-4 text-lg text-gray-900 font-semibold tracking-wider"
        animate={{ opacity: [0.4, 1, 0.4], scale: [1, 1.1, 1] }}
        transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
      >
        Loading...
      </motion.p>
    </motion.div>
  );
};

export default BlackLoader;
